export const GET_STORE_CATEGORIES_START = 'GET_STORE_CATEGORIES_START';
export const GET_STORE_CATEGORIES_SUCCESS = 'GET_STORE_CATEGORIES_SUCCESS';
export const GET_STORE_CATEGORIES_FAILED = 'GET_STORE_CATEGORIES_FAILED';

export const GET_STORE_CATEGORIES_TREE_START = 'GET_STORE_CATEGORIES_TREE_START';
export const GET_STORE_CATEGORIES_TREE_SUCCESS = 'GET_STORE_CATEGORIES_TREE_SUCCESS';
export const GET_STORE_CATEGORIES_TREE_FAILED = 'GET_STORE_CATEGORIES_TREE_FAILED';

export const CHANGE_STORE_CATEGORY_VALUE = 'CHANGE_STORE_CATEGORY_VALUE';
export const CHANGE_HOMEPAGE_CATEGORY_VALUE = 'CHANGE_HOMEPAGE_CATEGORY_VALUE';

export const CANCEL_ALL_STORE_CATEGORIES_CHANGES = 'CANCEL_ALL_STORE_CATEGORIES_CHANGES';

export const SAVE_STORE_CATEGORY_START = 'SAVE_STORE_CATEGORY_START';
export const SAVE_STORE_CATEGORY_SUCCESS = 'SAVE_STORE_CATEGORY_SUCCESS';
export const SAVE_STORE_CATEGORY_FAILED = 'SAVE_STORE_CATEGORY_FAILED';

export const CREATE_STORE_CATEGORY_START = 'CREATE_STORE_CATEGORY_START';
export const CREATE_STORE_CATEGORY_SUCCESS = 'CREATE_STORE_CATEGORY_SUCCESS';
export const CREATE_STORE_CATEGORY_FAILED = 'CREATE_STORE_CATEGORY_FAILED';

export const CHANGE_PRODUCT_CATEGORY_STATUS = 'CHANGE_PRODUCT_CATEGORY_STATUS';

export const getStoreCategoriesStart = () => ({
  type: GET_STORE_CATEGORIES_START
});

export const getStoreCategoriesSuccess = (data) => ({
  type: GET_STORE_CATEGORIES_SUCCESS,
  data
});

export const getStoreCategoriesFailed = () => ({
  type: GET_STORE_CATEGORIES_FAILED
});

export const getStoreCategoriesTreeStart = () => ({
  type: GET_STORE_CATEGORIES_TREE_START
});

export const getStoreCategoriesTreeSuccess = (data) => ({
  type: GET_STORE_CATEGORIES_TREE_SUCCESS,
  data
});

export const getStoreCategoriesTreeFailed = () => ({
  type: GET_STORE_CATEGORIES_TREE_FAILED
});

export const changeStoreCategory = (categoryId, name, value) => ({
  type: CHANGE_STORE_CATEGORY_VALUE,
  categoryId,
  name,
  value
});

export const changeHomepageCategory = (categoryId, name, value, path) => ({
  type: CHANGE_HOMEPAGE_CATEGORY_VALUE,
  categoryId,
  name,
  value,
  path
});

export const cancelAllStoreCategoriesChanges = () => ({
  type: CANCEL_ALL_STORE_CATEGORIES_CHANGES
});

export const saveStoreCategoryStart = () => ({
  type: SAVE_STORE_CATEGORY_START
});

export const saveStoreCategorySuccess = (category) => ({
  type: SAVE_STORE_CATEGORY_SUCCESS,
  category
});

export const saveStoreCategoryFailed = (error, category) => ({
  type: SAVE_STORE_CATEGORY_FAILED,
  error,
  category
});

export const createStoreCategoryStart = () => ({
  type: CREATE_STORE_CATEGORY_START
});

export const createStoreCategorySuccess = (data) => ({
  type: CREATE_STORE_CATEGORY_SUCCESS,
  data
});

export const createStoreCategoryFailed = (error, category) => ({
  type: CREATE_STORE_CATEGORY_FAILED,
  error,
  category
});

export const changeProductCategoryStatus = (categoryId) => ({
  type: CHANGE_PRODUCT_CATEGORY_STATUS,
  categoryId
});
